<template>
  <div>
    <Content title="SLA Performance Praqualifikasi K3L" />
  </div>
</template>
<script>
export default {
  components: {
    Content: () => import('@/components/dashboard/main-kpi/content.vue'),
  },
}
</script>
